module.exports = __webpack_public_path__ + "media/Video 88.ab4663d1.mp4";